import styled from "@emotion/styled";
import Input from "components/Input";
import Text from "components/Text";
import TextArea from "components/TextArea";
import { ChangeEvent, memo } from "react";

type InputWithErrorType = {
  name: string;
  customPlaceholder?: string;
  inputError: string;
  // eslint-disable-next-line
  onChange: (e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLTextAreaElement>) => void;
  type?: string;
};

const InputBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
`;
const Label = styled.label`
  position: relative;
  width: fit-content;
`;
const Error = styled.div`
  position: absolute;
  top: 0;
  width: max-content;
  left: 140%;
`;

const InputWithError = ({
  name,
  inputError,
  type = "text",
  customPlaceholder,
  onChange,
}: InputWithErrorType) => {
  const inputPlaceholder = name
    .split("")
    .map((letter, index) => (index === 0 ? letter.toUpperCase() : letter))
    .join("");

  return (
    <InputBlock>
      <Label htmlFor="message">
        <Text tag="span" variant="boldExtraSmall">
          {inputPlaceholder}
        </Text>
        <Error>
          <Text tag="span" variant="error">
            {inputError}
          </Text>
        </Error>
      </Label>
      {type === "textarea" ? (
        <TextArea
          name={name}
          id={name}
          onChange={onChange}
          placeholder={customPlaceholder || inputPlaceholder}
          className={`${inputError ? "with-error" : ""}`}
          rows={6}
        />
      ) : (
        <Input
          type={type}
          placeholder={customPlaceholder || inputPlaceholder}
          className={`${inputError ? "with-error" : ""}`}
          name={name}
          id={name}
          onChange={onChange}
        />
      )}
    </InputBlock>
  );
};

export default memo(InputWithError);
